<div class="start-planing">
  <figure class="start-planing__img-1">
    <img [src]="startPlanImgF | safeUrl" width="105" height="115" alt="start-plan-image">
  </figure>
  <figure class="start-planing__img-2">
    <img [src]="startPlanImgS | safeUrl" width="105" height="115" alt="start-plan-image">
  </figure>

  <h3>Ready for Your Next Trip?</h3>
  <p>Join RoutePerfect today to unlock all features and exclusive perks that will enhance your journey!</p>

  <button class="btn-default btn-orange btn-mobile" (click)="openPlanningForm()">
    Start planning
  </button>
</div>
